import generateText from './generateText'
import generateDownloadMetaText from './generateDownloadMetaText'
import generateName from './generateName'

const generateFullDownloadableText = (pattern, user, team, includeErrors, includeData, includeHidden, txtFormat) => { 

  let text = generateDownloadMetaText(pattern, {
    watermark: true, 
    user: user, 
    team: team, 
    includeErrors: includeErrors, 
    includeData: includeData, 
    includeHidden: includeHidden,
  });

  let tempPatternText = pattern.text + "";

  if(!includeHidden){
    let rows = tempPatternText.split('\n');
    tempPatternText = "";
    let startIndex = 7;
    if(pattern.format == "AUTOCAD"){
      startIndex = 3;
    }

    for(var i = 0; i < rows.length; i++){

      if(pattern.rows[i - startIndex]){
        if(pattern.rows[i - startIndex].invisible){
          continue;
        } 
      }
      
      tempPatternText += rows[i];

      if(i < rows.length - 1){
        tempPatternText += '\n';
      }
    }

  }

  text += tempPatternText;

  return text;
}

export default generateFullDownloadableText;



// WEBPACK FOOTER //
// ./src/pattern_utilities/generateFullDownloadableText.js